import { User } from './User.types';

const nameClaim: string =
    'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name';
const roleClaim: string =
    'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
const emailClaim: string =
    'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress';
const expClaim: string = 'exp';
const authTimeClaim: string = 'auth_time';
const scopeClaim: string = 'scope';
const rangeMarketClaim: string = 'range_market';
const regionClaim: string = 'region';
const userId: string = 'sub';

const base64Decode = (str: string): string => {
    // Decode a base64 encoded string with UTF-8 support. https://stackoverflow.com/a/30106551
    const decodedData = window.atob(str);
    const utf8Chars = decodedData.split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    });

    return window.decodeURIComponent(utf8Chars.join(''));
};

export const tokenToUserConverter = (token: string): User => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const claims = JSON.parse(base64Decode(base64));
    const regionId = parseInt(claims[regionClaim]) || 1;

    return {
        access_token: token,
        auth_time: claims[authTimeClaim],
        email: claims[emailClaim],
        expiration: claims[expClaim],
        name: claims[nameClaim],
        rangeMarket: claims[rangeMarketClaim],
        region: regionId,
        role: claims[roleClaim],
        scope: claims[scopeClaim],
        userId: claims[userId]
    };
};
